function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import cn from 'classnames';
import find from 'lodash/find';
import isObjectLike from 'lodash/isObjectLike';
import intlShape from 'shapes/intlShape';
import Input from './Input';
var _React_PureComponent;
class InputLikeCheckboxRadio extends (_React_PureComponent = React.PureComponent) {
    onChange(input) {
        if (this.props.isRadio) {
            return this.props.onChange({
                id: this.props.id,
                value: input.value
            });
        }
        let value = this.props.value ? this.props.value : [];
        if (input.value) {
            value = [
                ...value,
                input.value
            ];
        } else {
            value = value.filter((v)=>v !== this.props.inputValue);
        }
        return this.props.onChange({
            id: this.props.id,
            value
        });
    }
    get value() {
        if (this.props.isRadio) {
            return this.props.value;
        }
        return find(this.props.value, (i)=>i === this.props.inputValue.toString());
    }
    get isChecked() {
        return this.value === this.props.inputValue;
    }
    renderInfo() {
        if (!this.props.infoMessage) {
            return null;
        }
        return /*#__PURE__*/ _jsx("p", {
            className: "form-info",
            children: isObjectLike(this.props.infoMessage) ? this.props.intl.formatMessage(this.props.infoMessage, _object_spread({}, this.props.infoMessage.values)) : this.props.infoMessage
        });
    }
    render() {
        const attributes = {
            checked: this.isChecked
        };
        const id = `${this.props.id}-${this.props.inputValue}`;
        return /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs("label", {
                    htmlFor: id,
                    className: cn('form-control', this.props.className, {
                        disabled: this.props.isDisabled
                    }),
                    children: [
                        this.props.renderImage && this.props.renderImage(),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "row h-100 align-items-center",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col",
                                    children: isObjectLike(this.props.labelMessage) ? this.props.intl.formatMessage(this.props.labelMessage, _object_spread({}, this.props.labelMessage.values)) : this.props.labelMessage
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "col-auto",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: cn({
                                            'uniform-checker': !this.props.isRadio,
                                            'uniform-choice': this.props.isRadio,
                                            disabled: this.props.isDisabled
                                        }),
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: cn('form-input__hover', {
                                                    disabled: this.props.isDisabled
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                className: cn({
                                                    checked: this.isChecked
                                                }),
                                                children: /*#__PURE__*/ _jsx(Input, {
                                                    id: id,
                                                    type: this.props.isRadio ? 'radio' : 'checkbox',
                                                    value: this.props.inputValue,
                                                    formControl: false,
                                                    attributes: attributes,
                                                    onChange: (input)=>this.onChange(input),
                                                    onBlur: this.props.onBlur,
                                                    isDisabled: this.props.isDisabled
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                }),
                this.renderInfo()
            ]
        });
    }
}
_define_property(InputLikeCheckboxRadio, "propTypes", {
    // Explicit props
    id: PropTypes.string,
    inputValue: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array
    ]),
    labelMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    infoMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isRadio: PropTypes.bool,
    isDisabled: PropTypes.bool,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    renderImage: PropTypes.func,
    // Implicit props
    intl: intlShape.isRequired,
    // Explicit Actions
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func
});
_define_property(InputLikeCheckboxRadio, "defaultProps", {
    id: '',
    value: '',
    isRadio: false,
    isDisabled: false,
    className: '',
    onBlur: ()=>{}
});
export default injectIntl(InputLikeCheckboxRadio);
